<template>
  <LogDetailComponent />
</template>

<script>
// @ is an alias to /src
import LogDetailComponent from "@/sections/voiceplus/components/LogDetailComponent.vue";

export default {
  name: "Logs",
  components: {
    LogDetailComponent,
  },
};
</script>
